module.exports = __webpack_public_path__ + "img/bttn_pimlico_map.ae586aa8.png";